import { flog } from '@zambezi/caballo-vivo';
import { concat, of, EMPTY } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
export function catchAndStowError(additionalErrorHandler$) {
  return function (source$) {
    return source$.pipe(catchError(restoreWarning(function (error) {
      return concat(of(stowErrorState(error)), additionalErrorHandler$ ? additionalErrorHandler$(error) : EMPTY);
    })));
  };
}
export var restore = restoreWarning(function (error, store$) {
  return store$.pipe(take(1), map(stowErrorState(error)), flog('Error recovered'));
});
export var serviceUnavailableChecker = function serviceUnavailableChecker(error, store$) {
  if (error.type === 'service-unavailable') {
    return store$.pipe(take(1), map(function (state) {
      return state.set('error', error);
    }), flog('Service Error recovered'));
  }
  throw error;
};
export function createErrorWithType(message, type) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Object.assign(new Error(message), {
    type: type
  }, {
    payload: payload
  });
}
export function warn() {
  if (global.localStorage && global.localStorage.getItem('cv-log')) {
    var _console;
    (_console = console).warn.apply(_console, arguments);
  }
}
export function restoreWarning(restoreFn) {
  return function (error) {
    warn('Recovering from:', error);
    return restoreFn.apply(this, arguments);
  };
}
function stowErrorState(error) {
  return function (state) {
    return state.set('error', error).delete('loading').delete('modal');
  };
}